function setInSession(key, value) {
  sessionStorage.setItem(key, value);
}
function getFromSession(key) {
  return sessionStorage.getItem(key);
}
function setCookie(cname, cvalue, exdays = 1, domain) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};${domain ? `domain=${domain}` : ''};path=/`;
}
function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}
function deleteCookie(name) {
  document.cookie = name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
function deleteAllCookies() {
  console.log('deleting..');
  var allCookies = document.cookie.split(';');
  for (let i = 0; i < allCookies.length; i++) document.cookie = allCookies[i] + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
export { setInSession, setCookie, getCookie, getFromSession, deleteCookie, deleteAllCookies };